import { Client } from "./_clientService";

async function createTutorialConfig(operatorId: string) {
  try {
    const resp = await new (Client as any)({
      path: "/tutorial/create",
      payload: { operatorId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function getTutorialConfig(operatorId: string) {
  try {
    const resp = await new (Client as any)({
      path: `/tutorial/config/${operatorId}`,
    }).get();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function getTutorialList() {
  try {
    const resp = await new (Client as any)({
      path: "/tutorial/list",
    }).get();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateTutorialConfigStatus(
  operatorId: string,
  isEnabled: boolean,
) {
  try {
    const resp = await new (Client as any)({
      path: "/tutorial/update/status",
      payload: { operatorId, isEnabled },
    }).patch();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function uploadTutorialVideo(
  operatorId: string,
  languageCode: string,
  file: File,
) {
  try {
    // Step 1: Request presigned URL from backend
    const presignedResp = await new (Client as any)({
      path: "/tutorial/upload",
      payload: {
        operatorId,
        languageCode,
        fileType: file.type,
        fileSize: file.size,
      },
    }).post();

    const { fileUploadUrl, tutorialConfig } = presignedResp?.data || {};

    if (!fileUploadUrl) {
      throw new Error("Failed to get upload URL");
    }

    // Step 2: Upload file directly to S3 using presigned URL
    const uploadResponse = await fetch(fileUploadUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload video to storage");
    }

    return { data: tutorialConfig };
  } catch (error) {
    throw error;
  }
}

async function deleteTutorialVideo(operatorId: string, languageCode: string) {
  try {
    const resp = await new (Client as any)({
      path: `/tutorial/video/${operatorId}/${languageCode}`,
    }).delete();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function deleteTutorialConfig(operatorId: string) {
  try {
    const resp = await new (Client as any)({
      path: `/tutorial/config/${operatorId}`,
    }).delete();
    return resp;
  } catch (error) {
    throw error;
  }
}

export {
  createTutorialConfig,
  getTutorialConfig,
  getTutorialList,
  updateTutorialConfigStatus,
  uploadTutorialVideo,
  deleteTutorialVideo,
  deleteTutorialConfig,
};
